import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './pagina_robin_tattooart.module.scss';
import Foto from './src/background-links.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { INSTAGRAM_URL, MAPS_URL, WHATSAPP_DEFAULT, useRobinBackground } from './dados_robin_tattooart.ts';

const ease = [0.22, 1, 0.36, 1] as const;

const ESPECIALIDADES = ['Realismo preto e cinza'];

const SECOES = [
    {
        titulo: 'Trajetória',
        texto: 'Sou Robson Izael, artista cursado com 3 anos de experiência na área e mais de 8 cursos concluídos, sempre em busca de evolução e aperfeiçoamento.',
    },
    {
        titulo: 'Reconhecimento',
        texto: 'Ao longo da minha trajetória, tive a honra de ser premiado em convenções mais de uma vez, reconhecimento que reforça minha dedicação e amor pela arte.',
    },
    {
        titulo: 'Especialidade',
        texto: 'Sou especialista em realismo preto e cinza, um estilo que me permite expressar emoção, profundidade e detalhes únicos em cada trabalho.',
    },
    {
        titulo: 'Missão',
        texto: 'Minha missão é transformar ideias em arte, eternizando histórias e sentimentos através da pele.',
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 16 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease } },
};

const Sobre_mim_robin_tattooart: React.FC = () => {
    useRobinBackground();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina} lang="pt-BR">
            <div className={styles.header}>
                <Link to="/robin_tattooart" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.headerTitle}>Sobre mim</h1>
            </div>

            <motion.img
                className={styles.portrait}
                src={Foto}
                alt="Robson Izael"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.9, ease }}
            />

            <div className={styles.page}>
                <p className={styles.eyebrow}>Tatuador</p>
                <h2 className={styles.name}>Robson Izael</h2>

                <div className={styles.chips}>
                    {ESPECIALIDADES.map((item) => (
                        <span key={item} className={styles.chip}>
                            {item}
                        </span>
                    ))}
                </div>

                {SECOES.map((secao, index) => (
                    <motion.section
                        key={secao.titulo}
                        className={styles.section}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, amount: 0.35 }}
                        transition={{ delay: index * 0.04 }}
                    >
                        <h3 className={styles.sectionTitle}>{secao.titulo}</h3>
                        <p className={styles.paragraph}>{secao.texto}</p>
                    </motion.section>
                ))}

                <p className={styles.quote}>
                    Transformar ideias em arte, eternizando histórias e sentimentos através da pele.
                </p>

                <div className={styles.cta}>
                    <a
                        href={WHATSAPP_DEFAULT}
                        className={styles.ctaBtn}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#c4a574" />
                        Agendar
                    </a>
                </div>
            </div>

            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href={WHATSAPP_DEFAULT} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <WhatsappIcon height="26" color="#c4a574" />
                        </div>
                        <span>WhatsApp</span>
                    </a>
                    <a href={MAPS_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <MapsIcon height="26" color="#c4a574" />
                        </div>
                        <span>Localização</span>
                    </a>
                    <a href={INSTAGRAM_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <InstagramIcon height="22" color="#c4a574" />
                        </div>
                        <span>Instagram</span>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{' '}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_robin_tattooart;
